<template>
  <div class="settings_tab">

    <h3 id="individual_settings">Настройки аккаунта</h3>

    <div class="individual panels" v-show="true">

      <div class="col one">
        <div class="panel">
          <h4>Контактные данные</h4>
          <div class="content">
            <div class="fields">
              <standart-filed
                  id="fio" title="ФИО" type="text" placeholder="Иванов Иван Иванович"
                  :value="account.fio"
                  @updated="account.fio = $event"
                  :error-text="account_errors.fio"
              >
              </standart-filed>
              <div class="fields_row">
                <standart-filed
                    id="phone" title="Телефон" type="text" placeholder="+7 (900) 000-00-00"
                    :value="account.phone"
                    @updated="account.phone = $event"
                    :error-text="account_errors.phone"
                    mask="+7 (###) ###-##-##"
                >
                </standart-filed>
                <standart-filed
                    id="email" title="Почта" type="text" placeholder="info.mail@yandex.ru"
                    :value="account.email"
                    @updated="account.email = $event"
                    :error-text="account_errors.email"
                >
                </standart-filed>
              </div>
              <div class="fields_row">
                <standart-filed
                    id="date" title="Дата рождения" type="date" placeholder="08.07.1990"
                    :value="account.birthday"
                    @updated="account.birthday = $event"
                    :error-text="account_errors.birthday"
                >
                </standart-filed>
                <standart-radio
                    title="Выберите пол"
                    name="gender"
                    :variants="account.gender_list"
                    :current_variant="account.gender_current"
                    @radio_change="account.gender_current = $event; account.gender = $event.value"
                    :error-text="account_errors.gender"
                >
                </standart-radio>
              </div>
            </div>
            <div class="confirm">
              <standart-checkbox
                  :checked="account.conf_privacy_policy"
                  @change="account.conf_privacy_policy = $event"
                  :error-text="account_errors.conf_privacy_policy"
              ><template v-slot:text_content>
                Нажимая на кнопку, я <a href="#">принимаю условия соглашения</a>
              </template></standart-checkbox>

              <div class="share_error_b" v-show="account_error != ''">
                <p v-html="account_error"></p>
              </div>

              <standart-button @click="saveAccount()" text="Сохранить изменения"></standart-button>
            </div>
          </div>
        </div>
      </div>

      <div class="col two">
        <avatar-setter :photo="account.photo" type="account"></avatar-setter>
      </div>

    </div>

    <h3 id="legal_settings">Настройки контрагентов</h3>

    <div class="legal panels" v-show="true">
      <div class="col one">
        <div class="panel selector">
          <h4>Укажите данные компании</h4>
          <div class="content">
            <dropdown-filed
                title="Контрагенты"
                c_style=""
                :current='current_counterparty'
                :list="counterparties"
                @change="fillCounterparty($event)"
            >
            </dropdown-filed>
            <standart-button v-if="false" text="Создать контрагента"></standart-button>
          </div>
        </div>
        <avatar-setter v-show="counterparty.id != 0" :photo="counterparty.image" type="counterparty" :counterparty-id="counterparty.id"></avatar-setter>
      </div>
      <div class="col two">
        <div class="panel">
          <h4>Контактные данные</h4>
          <div class="content">
            <div class="fields">
              <div class="fields_row">
                <standart-filed
                    id="company" title="Название компании" type="text" placeholder="Название компании"
                    :value="counterparty.title"
                    @updated="counterparty.title = $event"
                    :error-text="counterparty_errors.title"
                    disabled="true"
                >
                </standart-filed>
                <standart-filed
                    id="inn" title="ИНН" type="text" placeholder="ИНН"
                    :value="counterparty.inn"
                    @updated="counterparty.inn = $event"
                    :error-text="counterparty_errors.inn"
                    disabled="true"
                >
                </standart-filed>
              </div>
              <div class="fields_row">
                <standart-filed
                    id="kpp" title="КПП" type="text" placeholder="КПП"
                    :value="counterparty.kpp"
                    @updated="counterparty.kpp = $event"
                    :error-text="counterparty_errors.kpp"
                    disabled="true"
                >
                </standart-filed>
                <standart-filed
                    id="ogrn" title="ОГРН/ОГРНИП" type="text" placeholder="ОГРН/ОГРНИП"
                    :value="counterparty.ogrn"
                    @updated="counterparty.ogrn = $event"
                    :error-text="counterparty_errors.ogrn"
                    disabled="true"
                >
                </standart-filed>
              </div>
              <div class="fields_row">
                <standart-filed
                    id="phone" title="Телефон компании" type="text" placeholder="+7 (900) 000-00-00"
                    :value="counterparty.phone"
                    @updated="counterparty.phone = $event"
                    mask="+7 (###) ###-##-##"
                    :error-text="counterparty_errors.phone"
                    disabled="true"
                >
                </standart-filed>
                <standart-filed
                    id="email" title="Почта компании" type="text" placeholder="info.mail@yandex.ru"
                    :value="counterparty.email"
                    @updated="counterparty.email = $event"
                    :error-text="counterparty_errors.email"
                    disabled="true"
                >
                </standart-filed>
              </div>
              <standart-filed
                  id="legal_address" title="Юридический адрес" type="text" placeholder="Юридический адрес"
                  :value="counterparty.l_address"
                  @updated="counterparty.l_address = $event"
                  :error-text="counterparty_errors.l_address"
                  disabled="true"
              >
              </standart-filed>
              <address-filed title="Фактические адреса" ref="address_filed"></address-filed>
            </div>
            <div v-if="false" class="confirm">
              <standart-checkbox
                  :checked="counterparty.conf_privacy_policy"
                  @change="counterparty.conf_privacy_policy = $event"
                  :error-text="counterparty_errors.conf_privacy_policy"
              ><template v-slot:text_content>
                Нажимая на кнопку, я <a href="#">принимаю условия соглашения</a>
              </template></standart-checkbox>

              <div class="share_error_b" v-show="counterparty_error != ''">
                <p v-html="counterparty_error"></p>
              </div>

              <standart-button v-if="false" @click="saveCounterparty()" text="Сохранить изменения"></standart-button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AvatarSetter from "@/components/main/tabs/SettingsTab/AvatarSetter";
import StandartFiled from "@/components/share/StandartField";
import StandartRadio from "@/components/share/StandartRadio";
import StandartButton from "@/components/share/StandartButton";
import StandartCheckbox from "@/components/share/StandartCheckbox";
import AddressFiled from "@/components/share/AddressField";
import DropdownFiled from "@/components/share/DropdownField";
import axios from "axios";

export default {
  name: 'SettingsTab',
  components: {
    DropdownFiled,
    AddressFiled,
    StandartCheckbox,
    StandartButton,
    StandartRadio,
    StandartFiled,
    AvatarSetter,
  },
  data() {
    return{
      account: {
        photo: null,
        conf_privacy_policy: false
      },
      account_errors: {
        fio: "",
        phone: "",
        email: "",
        birthday: "",
        gender: "",
        conf_privacy_policy: ""
      },
      account_error: "",

      counterparties: [],
      current_counterparty: {
        id: 0,
        title: "Новый контрагент",
        image: "https://stp62.ru/upload/users_logo/empty.svg"
      },
      counterparty: {
        id:0,
        image: "https://stp62.ru/upload/users_logo/empty.svg",
        title: "",
        inn: "",
        kpp: "",
        ogrn: "",
        phone: "",
        email: "",
        l_address: "",
        conf_privacy_policy: false
      },
      counterparty_errors: {
        title: "",
        inn: "",
        kpp: "",
        ogrn: "",
        phone: "",
        email: "",
        l_address: "",
        f_addresses: "",
        conf_privacy_policy: ""
      },
      counterparty_error: "",
    }
  },
  methods : {
    loadData: async function() {
      let res = await axios.get(window.api_url + "main/settings");

      this.account = res.data.data.account;

      this.counterparties = res.data.data.counterparties;



      if(this.account.profile_id > 0) {
        for(let counterparty of this.counterparties) {
          if(counterparty.id == this.account.profile_id) {
            this.current_counterparty.id = counterparty.id;
            this.current_counterparty.title = counterparty.title;
          }
        }
      }
      else {
        this.current_counterparty.id = this.counterparties[0].id;
        this.current_counterparty.title = this.counterparties[0].title;
      }

      if(this.account.profile_id > 0) {
        this.fillCounterparty(this.account.profile_id);
      }
      else {
        this.fillCounterparty(this.counterparties[0].id);
      }
    },
    saveAccount: async function() {
      console.log("saveAccount");
      if(!this.validateAccount()) {
        console.log("validate error");
        return;
      }

      const bodyFormData = new FormData;

      for(let field in this.account) {
        bodyFormData.append(field, this.account[field]);
      }

      try {

        let res = await axios.post(window.api_url + 'main/save_settings', bodyFormData);

        if (res.data.status === "fail") {
          this.account_error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    },
    validateAccount: function() {
      for(let field in this.account) {this.account_errors[field] = "";}
      this.account_error = "";

      let validation = true;

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      for(let field in this.account) {

        if(this.account[field] == "" && field != "profile_id") {
          this.account_errors[field] = "Обязательное поле";
          validation = false;
        }

        if(field == "email"){
          if(!EMAIL_REGEXP.test(this.account[field]) && this.account[field] != "") {
            this.account_errors[field] = "Электронная почта введена некорректно";
            validation = false;
          }
        }

        if(field == "phone"){
          if(this.account[field]?.replaceAll(/\D*/gm, '').length <= 10 && this.account[field] != "") {
            this.account_errors[field] = "Телефон введен некорректно";
            validation = false;
          }
        }

      }

      console.log(this.account_errors);

      return validation;
    },
    fillCounterparty: function(id) {
      for(let field in this.counterparty) {this.counterparty_errors[field] = "";}
      this.counterparty_error = "";

      for(let counterparty of this.counterparties) {
        if(counterparty.id == id) {
          if(id != 0) {
            this.counterparty = structuredClone(counterparty);

            this.$refs.address_filed.currentAddresses = counterparty.f_addresses;
          }
          else {
            this.counterparty = {
              id:0,
              image: "https://stp62.ru/upload/users_logo/empty.svg",
              title: "",
              inn: "",
              kpp: "",
              ogrn: "",
              phone: "",
              email: "",
              l_address: "",
              conf_privacy_policy: false
            }
          }
        }
      }
    },
    saveCounterparty: async function() {
      console.log(this.counterparty);

      if(!this.validateCounterparty()) {
        return;
      }

      const bodyFormData = new FormData;

      for(let field in this.counterparty) {
        bodyFormData.append(field, this.counterparty[field]);
      }

      bodyFormData.delete("f_addresses");
      for (let i = 0; i < this.$refs.address_filed.currentAddresses.length; i++) {
        bodyFormData.append('f_addresses[]', this.$refs.address_filed.currentAddresses[i]);
      }

      try {

        let res = await axios.post(window.api_url + 'counterparty/save', bodyFormData);

        if (res.data.status === "fail") {
          this.counterparty_error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    },
    validateCounterparty: function() {
      for(let field in this.counterparty) {this.counterparty_errors[field] = "";}
      this.counterparty_error = "";

      let validation = true;

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      for(let field in this.counterparty) {

        if((this.counterparty[field] === "" || this.counterparty[field] === false) && field != "f_addresses") {
          this.counterparty_errors[field] = "Обязательное поле";
          validation = false;
        }

        if(field == "email"){
          if(!EMAIL_REGEXP.test(this.counterparty[field]) && this.counterparty[field] != "") {
            this.counterparty_errors[field] = "Электронная почта введена некорректно";
            validation = false;
          }
        }

        if(field == "phone"){
          if(this.counterparty[field]?.replaceAll(/\D*/gm, '').length <= 10 && this.counterparty[field] != "") {
            this.counterparty_errors[field] = "Телефон введен некорректно";
            validation = false;
          }
        }

      }

      return validation;
    },
  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>

.settings_tab {

}

.share_error_b p {
  color: var(--Red, #FA4B61);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
}

.settings_tab h3{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin: 0px;
  display: flex;
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 16px;
}

.panels {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.col {

}

.individual .col.one {
  min-width: 544px;
  width: 100%;
  flex: 1;
}

.individual .col.two {
  width: 100%;
  flex: 1;
}

.legal .col.one {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.legal .col.two {
  min-width: 544px;
  width: 100%;
  flex: 1;
}

.col .panel {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 20px;
}

.col .panel h4{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  margin: 0px 0px 24px 0px;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.fields {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.fields_row {
  display: flex;
  gap: 16px;
}

.fields_row div {
  flex: 1;
}

.confirm {
  display: flex;
  gap: 14px;
  flex-direction: column;
  margin-top: 95px;
}

.legal .confirm {
  margin-top: 40px;
}

.legal .selector .content {
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: end;
}

.legal .selector .content .standart_field {
  min-width: 299px;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .individual {
    flex-direction: column-reverse;
    gap: 10px;
  }

  .individual .col.one {
    min-width: unset;
  }

  .legal {
    flex-direction: column;
    gap: 10px;
  }

  .legal .col.one {
    flex-direction: column-reverse;
    gap: 10px;
  }

  .legal .col.two {
    min-width: unset;
  }

  .legal .panel .content {
    flex-direction: column;
  }

  .col .panel {
    padding: 18px;
  }

  .fields_row {
    flex-direction: column;
  }

  .confirm {
    margin-top: 24px;
  }

}
</style>